import '@vaadin/email-field';
import { componentName, EmailFieldClass } from './EmailFieldClass';

customElements.define(componentName, EmailFieldClass);

export { EmailFieldClass, componentName };
